<template>
	<div class="table-wrapper">
		<table class="mt-3 body-2">
			<template v-for="(attr, n) in attributes">
				<tr v-bind:key="n">
					<th class="pa-1">{{attr.key}}</th>
					<td class="pa-1" v-html="attr.value"></td>
				</tr>
			</template>
		</table>
	</div>
</template>

<script>
	export default {
		props: {
			meta: Object,
			filter: Boolean
		},
		computed: {
			attributes: {
				get: function(){					
					var metaAttributes = this.meta.attributes[0] || this.meta.attributes,
						attributes = [],
						skip;
					for (var key in metaAttributes) {
						skip = false;
						if (this.filter) {
							if (["actions", "extent", "restrictions", "date_modified", "lang", "linked_uuid", "score", "data_provider", "creation_date", "revision_date", "publish_date"].indexOf(key) != -1) {
								skip = true;
							}
							if (key == "profile") {
								var imgClasses = ["inspire", "nmdp", "atom"],
									matchedImgClass;
								imgClasses.some(function(imgClass){
									if (metaAttributes[key].indexOf(imgClass) === 0) {
										matchedImgClass = imgClass;
										return true;
									}
								});
								if (matchedImgClass) {
									metaAttributes[key] = '<img src="https://www.geoportal.lt/map/resources/images/dataSearchItemTypes/' + matchedImgClass + '.png' + '" title="' + metaAttributes[key] + '">';
								}
							}
						}
						if (!skip) {
							attributes.push({
								key: this.filter ? this.getPrettyKeyValue(key) : key,
								value: metaAttributes[key]
							});
						}
					}					
					return attributes;
				}
			}
		},
		methods: {
			getPrettyKeyValue: function(key){
				var values = {
					description: "Santrauka",
					author: "Autorius",
					rating: "Vidutinis įvertinimas",
					rating_count: "Vertino",
					profile: "Metaduomenų profilis",
					publish_date: "Publikavimo data"
				};
				return values[key] || key;
			}
		}
	}
</script>

<style scoped>
	.table-wrapper {
		width: 100%;
		overflow: auto;
	}
	table {
		border-collapse: collapse;
	}
	td, th {
		border: 1px solid #cccccc;
		text-align: left;
		background: #FFFFFF;
		font-size: 0.875rem;
		font-family: "Roboto", sans-serif;
	}
</style>